<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Item Status</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="repairs"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- action template -->
              <template v-slot:item.ItemState="{ item }">
                <span v-if="item.ItemState == 0" style="color: orange; font-weight: bold">Pending Repair</span>
                <span v-if="item.ItemState == 1" style="color: blue; font-weight: bold">Repaired</span>
                <span v-if="item.ItemState == 2" style="color: red; font-weight: bold">Beyond Repair</span>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    activeItem: {},
    Dealer: null,
    assignDialog: false,
    zeroValue: 0,
    loader: false,
    pageItems: 100,
    headers: [
      { text: "Job No.", value: "JobNo" },
      { text: "Customer", value: "CustomerName" },
      { text: "Phone No.", value: "CustomerPhone" },
      { text: "Item", value: "product.Name" },
      { text: "Problem Details", value: "ProblemDetails" },
      { text: "Received By", value: "received_by.name" },
      { text: "Date Returned", value: "ReturnDate" },
      { text: "Item Status", value: "ItemState" }
    ],
    dealers: [],
    repairs: [],
  }),
  methods: {
    dealerModal(data) {
      this.activeItem = data;
      this.assignDialog = true;
    },
    assignDealer() {
      if (this.Dealer == null || this.Dealer == undefined) {
        this.$refs.snackbar.show("Please select dealer", "red");
      } else {
        const data = {
          id: this.activeItem.id, 
          Dealer: this.Dealer
        };
        const url = `/repair/assign/dealer`;
        const self = this;
        this.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show("Assigned successfully", "green");
              self.loader = false;
              self.assignDialog = false;
              self.getRepairs();
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getRepairs() {
      const self = this;
      this.$store
        .dispatch("get", `/all/repairs`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.repairs = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getRepairs();
  },
};
</script>